import {
    SET_PATH,
    CLEAR_PATH,
} from 'store/actions/types';

export const setPath = (payload) => {
    return {
        type: SET_PATH,
        payload: payload,
    };
};

export const clearPath = (payload) => {
    return {
        type: CLEAR_PATH,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pathActions.js